import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Box,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ConfirmDeleteDialog = ({ open, onDelete, onClose }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const doClose = (e) => {
    e.stopPropagation();
    onClose();
  };
  const doDelete = (e) => {
    e.stopPropagation();
    onDelete();
  };
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth='sm' 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: '8px',
        }
      }}
    >
      <DialogTitle sx={{ 
        fontWeight: 600, 
        fontSize: 20,
        color: '#18181B',
        pt: 2,
        pb: 1
      }}>
        {t('Delete conversation')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ 
          color: theme.palette.primary.light,
          fontSize: 16,
          mb: 1
        }}>
          {t('Delete this conversation?')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Box sx={{ display: 'flex', gap: 2, width: '100%', justifyContent: 'flex-end' }}>
          <Button 
            variant="cancelButton" 
            onClick={doClose}
            sx={{ minWidth: '100px', fontSize: 14 }}
          >
            {t('common.cancel')}
          </Button>
          <Button 
            variant="buttonStandard" 
            onClick={doDelete}
            sx={{ 
              minWidth: '100px',
              fontSize: 14,
            }}
          >
            {t('common.delete')}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
